import React from 'react';
import { Modal } from '@mantine/core';
import { Button } from '../../../../components/Button';
import classes from './takeover-confirm-modal.module.scss';

export type TakeoverConflict = {
  employeeId: number;
  employeeName: string;
  existingSessionId: string;
};

export type TakeoverConfirmModalProps = {
  conflict: TakeoverConflict | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Summary: Warning modal shown when an employee is already logged in on another device. Confirm triggers takeover flow; cancel returns to the picker.
// Details: docs/function-library/web/contexts-pages.md#pages-posshellpage-components
const TakeoverConfirmModalComponent: React.FC<TakeoverConfirmModalProps> = ({
  conflict,
  isSubmitting,
  onConfirm,
  onCancel,
}) => (
  <Modal
    opened={conflict !== null}
    onClose={() => {
      if (!isSubmitting) {
        onCancel();
      }
    }}
    title={<strong>המשתמש תפוס על ידי עובד אחר.</strong>}
    centered
    radius="md"
    closeOnClickOutside={!isSubmitting}
    closeOnEscape={!isSubmitting}
    closeButtonProps={{ 'data-testid': 'takeover-confirm-close' } as Record<string, string>}
    classNames={{ body: classes.body, header: classes.header, title: classes.title, close: classes.close }}
  >
    <div className={classes.stack}>
      <p className={classes.question}>האם ברצונך להיכנס במקומו?</p>
      <div className={classes.actions}>
        <Button variant="cancel" fullWidth onClick={onCancel} disabled={isSubmitting} dataTestId="takeover-confirm-cancel">
          ביטול
        </Button>
        <Button variant="confirm" fullWidth onClick={onConfirm} disabled={isSubmitting} loading={isSubmitting} dataTestId="takeover-confirm-confirm">
          אישור
        </Button>
      </div>
    </div>
  </Modal>
);

export const TakeoverConfirmModal = React.memo(TakeoverConfirmModalComponent);
